import { render } from "./CartButton.vue?vue&type=template&id=22a3e69a&scoped=true&ts=true"
import script from "./CartButton.vue?vue&type=script&lang=ts"
export * from "./CartButton.vue?vue&type=script&lang=ts"

import "./CartButton.vue?vue&type=style&index=0&id=22a3e69a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a3e69a"]])

export default __exports__